export default "__VITE_ASSET__DjjngYgL__"